
import myDeleteReq from "../../utils/delete";
import myGetReq from "../../utils/get";
import myPostReq from "../../utils/post";
import mytaskpost from "../../utils/tpost";
import myUpdateReq from "../../utils/update";


export const fetchTasks = async () => {
    try {
        return await myGetReq(
            `/app/usr/taskmanager-get-tasks`
        );
    } catch (err) {
        console.log("get req", err)
        return err;
    }
};


export const addTask = async (data) => {
    // let files = data.attachments
    console.log(data.attachments, "data from addtask")
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data))

    for (let i = 0; i < data.attachments.length; i++) {
        formdata.append("photos", data.attachments[i])
    }
    try {
        return await myPostReq("/app/usr/taskmanager-add-task", formdata, {});
    } catch (err) {
        return err;
    }
};


export const updateTask = async (data) => {
    console.log(data.newattachments, "data from updateData")
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data))

    for (let i = 0; i < data.newattachments.length; i++) {
        formdata.append("photos", data.newattachments[i])
    }
    try {
        return await myUpdateReq("/app/usr/taskmanager-update-task", formdata, {});
    } catch (err) {
        console.log(err, "update err")
        return err;
    }
};


export const deleteAttach = async (data) => {

    let jdata = JSON.stringify({ data: data })
    console.log("action dela", data)
    try {
        return await myDeleteReq("/app/usr/taskmanager-delete-attach", jdata);
    } catch (err) {
        console.log(err)
        return err;
    }
};


export const deleteTask = async (id, data) => {

    let jdata = JSON.stringify({ id, data })
    try {
        return await myDeleteReq("/app/usr/taskmanager-delete-task", jdata);
    } catch (err) {
        console.log(err)
        return err;
    }
};

